import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { breakpoints, utility, colors, borderRadius } = useTheme();

  return {
    btn: (primary, geolocation, statuscode, isSelectedAnswer) => css`
      ${utility.buttonDefault};
      font-size: 0.875rem;
      font-weight: 400;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: ${colors.white};
      background-color: ${colors.lightGrey};
      border-radius: ${borderRadius.s};
      padding: ${geolocation ? '0' : '0.85rem 1rem'};
      transition: all 0.3s ease-in;
      text-decoration: none;
      outline: 0;
      ${breakpoints.xl} {
        &:not(:disabled) {
          &:hover {
            background-color: ${colors.white};
            color: ${colors.navy};
          }
        }
      }
      ${breakpoints.mm_l_xl}{
        font-size: 1rem;
      }

      ${isSelectedAnswer === true &&
      css`
      &:not(:disabled) {
        &:hover {
          background-color: ${colors.yellow};
          color: ${colors.navy};
        }
      }
        
      &:not(:disabled) {
        &:focus {
          background-color: ${colors.white} !important;
          color: ${colors.navy} !important;

        ${
          statuscode === 'denied' &&
          css`
            background-color: ${colors.white} !important;
            color: ${colors.red} !important;
          `
          }
        }`
      }

      ${isSelectedAnswer === false &&
      css`
        ${breakpoints.xl} {
          &:not(:disabled) {
            &:hover {
              background-color: ${colors.white};
              color: ${colors.navy};
            }
          }
        }`
      }

      ${primary &&
      css`
        color: ${colors.white};
        background-color: ${colors.blue};

        &:not(:disabled) {
          &:hover {
            background-color: ${colors.darkBlue};
          }
        }
      `}

      &:disabled {
        background-color: ${colors.lightGrey};
        color: ${colors.darkGrey};
      }
    `,
  };
};
